import React from 'react'
import { Link } from 'react-router-dom'
import { useI18n } from '../state/I18nContext'
import { ENABLE_FUTURE_PAGES } from '../config'

const Shop: React.FC = () => {
  const { t, locale } = useI18n()
  const s = t.shop
  return (
    <section className="max-w-6xl mx-auto px-4 py-10">
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold">{s.title}</h1>
          <p className="text-neutral-600">{s.description}</p>
        </div>
        <span className="text-xs bg-emerald-600 text-white px-2 py-1 rounded">{s.badge}</span>
      </div>

      <ul className="grid md:grid-cols-3 gap-4 mb-8">
        {s.bullets.map((b, i) => (
          <li key={i} className="border border-neutral-200 rounded p-4">{b}</li>
        ))}
      </ul>

      <div className="mb-8">
        <Link to={ENABLE_FUTURE_PAGES ? `/${locale}/taste` : `/${locale}/#catalog`} className="inline-block bg-amber-600 text-white px-4 py-2 rounded hover:bg-amber-700">
          {s.cta}
        </Link>
      </div>

      <div>
        <h2 className="text-2xl font-semibold mb-2">{s.logisticsTitle}</h2>
        <p className="text-neutral-600 mb-4">{s.logisticsDescription}</p>
        <div className="grid md:grid-cols-2 gap-4">
          {s.logisticsFeatures.map((f, i) => (
            <div key={i} className="border border-neutral-200 rounded p-4">{f}</div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Shop
